import React from "react";
import { Search, Globe, RotateCcw, Clock } from "lucide-react";

interface ScannerInputProps {
  inputUrl: string;
  setInputUrl: (val: string) => void;
  onScan: (targetUrl?: string) => void;
  loading: boolean;
  history: string[];
}

export const ScannerInput: React.FC<ScannerInputProps> = ({
  inputUrl,
  setInputUrl,
  onScan,
  loading,
  history,
}) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (inputUrl.trim() && !loading) {
      onScan(inputUrl);
    }
  };

  return (
    <div className="scanner-section">
      <form onSubmit={handleSubmit}>
        <div className="scanner-box">
          <div className="protocol-tag">
            <Globe size={16} style={{ marginRight: "0.4rem" }} />
            HTTPS://
          </div>

          <input
            type="text"
            className="cyber-input"
            placeholder="Enter target website URL (e.g. bun.sh, github.com)..."
            value={inputUrl}
            onChange={(e) => setInputUrl(e.target.value)}
            disabled={loading}
          />

          <button type="submit" className="cyber-btn" disabled={loading || !inputUrl.trim()}>
            {loading ? (
              <>
                <RotateCcw size={18} className="spin-icon" />
                <span>SCANNING...</span>
              </>
            ) : (
              <>
                <Search size={18} />
                <span>SCAN MATRIX</span>
              </>
            )}
          </button>
        </div>
      </form>

      {history.length > 0 && (
        <div className="preset-pills">
          <span className="preset-label">
            <Clock size={12} style={{ display: "inline", marginRight: "0.2rem" }} />
            RECENT SCANS:
          </span>
          {history.slice(0, 4).map((hist) => (
            <button
              key={hist}
              type="button"
              className="preset-btn"
              style={{ borderColor: "rgba(0, 243, 255, 0.25)", color: "var(--neon-cyan)" }}
              onClick={() => {
                setInputUrl(hist);
                onScan(hist);
              }}
              disabled={loading}
            >
              {hist.replace(/^https?:\/\//, "")}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
